import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/visitTasksConstants';

const initialState = {
  visitTasks: [],
  visitTask: null,
  loading: true,
  totalPrice: 0,
  totalHours: 0,
};

const visitTasksReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_VISIT_TASKS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_VISIT_TASK:
      return {
        ...state,
        visitTask: null,
      };
    case types.GET_VISIT_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        visitTasks: payload,
        totalPrice: payload.reduce((total, item) => {
          return total + item.price;
        }, 0),
        totalHours: payload.reduce((total, item) => {
          return total + item.hours;
        }, 0),
      };
    case types.GET_VISIT_TASKS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_VISIT_TASKS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_VISIT_TASK:
      return {
        ...state,
        visitTask: payload,
      };
    default:
      return state;
  }
};

export default visitTasksReducer;
